import { useEffect, useRef, type ReactNode } from 'react';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  wide?: boolean;
  children: ReactNode;
  footer?: ReactNode;
}

/** Hộp thoại dùng thẻ <dialog> gốc: tự khóa nền, đóng bằng Esc, giữ giao diện của app cũ. */
export function Dialog({ open, title, onClose, wide, children, footer }: Props) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog ref={ref} className={`dlg${wide ? ' wide' : ''}`} onClose={onClose} onCancel={e => { e.preventDefault(); onClose(); }} aria-label={title}>
      {open && (
        <>
          <div className="dlg-h"><h3>{title}</h3><button type="button" className="btn small" onClick={onClose}>Đóng</button></div>
          <div className="dlg-b">{children}</div>
          {footer && <div className="dlg-f">{footer}</div>}
        </>
      )}
    </dialog>
  );
}
